import { render, staticRenderFns } from "./TrashList.vue?vue&type=template&id=32a52d5a&scoped=true&"
import script from "./TrashList.vue?vue&type=script&lang=js&"
export * from "./TrashList.vue?vue&type=script&lang=js&"
import style0 from "./TrashList.vue?vue&type=style&index=0&id=32a52d5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a52d5a",
  null
  
)

export default component.exports